import React, { forwardRef } from "react";
import { SectionCard, InfoRow, fmtLarge, C } from "../shared";

const AboutSection = forwardRef(({ d, details }, ref) => (
  <SectionCard ref={ref} id="about" icon="about" title="About & Company Details">
    <div className="tdash-g2">
      <div>
        <InfoRow label="Sector"      value={d.sector?.name} />
        <InfoRow label="Sector Code" value={d.sector?.code} />
        <InfoRow label="Face Value"  value={details.face_value ? `Rs. ${details.face_value}` : null} />
        <InfoRow label="Year End"    value={details.year_end} />
        <InfoRow label="Auditor"     value={details.auditor} />
        <InfoRow label="Registrar"   value={details.registrar} />
        <InfoRow label="Address"     value={details.address} />
        <InfoRow label="Website"     value={
          details.website
            ? <a href={details.website} target="_blank" rel="noopener noreferrer"
                 style={{ color: C.orange, textDecoration: "none", wordBreak: "break-all" }}>{details.website}</a>
            : null
        } />
      </div>
      <div>
        <p style={{ fontSize: 13, color: C.body, lineHeight: 1.85, margin: 0 }}>
          {details.description || "No description available."}
        </p>
        {(details.total_shares || details.free_float) && (
          <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div className="tdash-mini">
              <div className="tdash-mini-label">Total Shares</div>
              <div className="tdash-mini-value" style={{ color: C.orange }}>{fmtLarge(details.total_shares)}</div>
            </div>
            <div className="tdash-mini">
              <div className="tdash-mini-label">Free Float</div>
              <div className="tdash-mini-value" style={{ color: C.green }}>{fmtLarge(details.free_float)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  </SectionCard>
));

export default AboutSection;
